import { inject } from '@angular/core';
import { ResolveFn, Routes } from '@angular/router';

import { HomeComponent } from '@callcenter-app/pages/home/home.component';
import { CallCenterComponent } from '@callcenter-app/pages/call-center/call-center.component';
import { OrderViewComponent } from '@callcenter-app/pages/order/order-view/order-view.component';
import { CallsListComponent } from '@callcenter-app/pages/calls-list/calls-list.component';
import { CallsReportsComponent } from '@callcenter-app/pages/report/calls-reports/calls-reports.component';
import { CallsStatusReportComponent } from '@callcenter-app/pages/report/calls-status-report/calls-status-report.component';
import { CallsHoursReportComponent } from '@callcenter-app/pages/report/calls-hours-report/calls-hours-report.component';
import { OperatorOrderStatReportComponent } from '@callcenter-app/pages/report/operator-order-stat/operator-order-stat.component';
import { FeedbackRatingReportComponent } from '@callcenter-app/pages/report/feedback-rating/feedback-rating-report.component';
import { HxOrderService, OrderResponse } from 'hx-services';
import { UserListComponent } from '@callcenter-app/pages/user/user-list/user-list.component';
import { UserEditComponent } from '@callcenter-app/pages/user/user-edit/user-edit.component';
import { orderRoutes } from 'hx-order';
import { monitoringReportGuard } from '@callcenter-app/service/monitoring-report.guard';

const orderResolveFn: ResolveFn<OrderResponse> = route => inject(HxOrderService)
    .getFullOrderById(Number(route.paramMap.get('id')));

export const ROUTES: Routes = [
  {
    path: '',
    component: HomeComponent,
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'call-center'
      },
      {
        path: 'call-center',
        component: CallCenterComponent,
      },
      {
        path: 'clients',
        loadComponent: () => import('hx-component').then(m => m.HxClientListComponent)
      },
      {
        path: 'orders',
        children: orderRoutes
      },
      {
        path: 'orders/:id',
        component: OrderViewComponent,
        pathMatch: 'full',
        resolve: {
          order: orderResolveFn,
        }
      },
      {
        path: 'calls',
        component: CallsListComponent,
      },
      {
        path: 'calls-new',
        loadComponent: () => import('@callcenter-app/pages/calls-new/calls-new.component').then(m => m.CallsNewComponent)
      },
      {
        path: 'feedbacks-new',
        loadComponent: () => import('@callcenter-app/pages/feedbacks-new/feedbacks-new.component').then(m => m.FeedbacksNewComponent)
      },
      {
        path: 'rejections',
        loadComponent: () => import('hx-component').then(m => m.HxRejectionListComponent)
      },
      {
        path: 'users',
        children: [
          {
            path: '',
            component: UserListComponent,
          },
          {
            path: 'new',
            component: UserEditComponent,
          },
          {
            path: ':id/edit',
            component: UserEditComponent,
          },
        ]
      },
      {
        path: 'report',
        children: [
          {
            path: 'calls',
            component: CallsReportsComponent,
          },
          {
            path: 'calls-status',
            component: CallsStatusReportComponent,
          },
          {
            path: 'calls-hours',
            component: CallsHoursReportComponent
          },
          {
            path: 'operator-order-stat',
            component: OperatorOrderStatReportComponent
          },
          {
            path: 'feedback-rating',
            component: FeedbackRatingReportComponent
          },
          {
            path: 'monitoring',
            canActivate: [monitoringReportGuard],
            loadComponent: () => import('@callcenter-app/pages/report/monitoring/monitoring.component').then(m => m.MonitoringComponent)
          },
        ]
      },
      {
        path: 'faq/list',
        loadComponent: () => import('hx-component').then(m => m.HxFaqListComponent)
      },
    ]
  },
  {
    path: '**',
    redirectTo: 'call-center'
  }
];
